import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import upload from './../../../../Assets/Images/cloud.svg'
import { getFileCategory, isValidString } from "../../../../helper";
import { cloudFileUpload, generatePresignedURL } from "../../../../redux/actions/cloudFileUpload";
import { getTicketList, postTicketAction } from "../../../../redux/actions/ticket";
import "./style.css";
import { Notify } from "notiflix";

const CloseTicket = ({ data, show, handleClose }) => {

  const initFormData = {
    title: data?.title,
    comment: "",
    actionType: "TICKET_CLOSED"
  }

  const dispatch = useDispatch();

  const [formData, setFormData] = useState(initFormData);
  const [error, setError] = useState({})

  const handleInputChange = e => setFormData({ ...formData, [e.target.name]: e.target.value })

  const handleFileChange = (event) => {
    const { files } = event.target;
    if (files?.length) {
      const fileType = files[0].name.split('.').pop();
      const Type = getFileCategory(fileType);
      dispatch(generatePresignedURL({ file_type: Type, upload_type: "TICKET" }, (url) => {
        dispatch(cloudFileUpload({ url, file: files[0] }, imageUrl => {
          setFormData({ ...formData, attachments: [{ fileType: Type, fileUrl: imageUrl }] })
        }))
      }))
    }
  }

  const handleCloseTicket = () => {
    const postData = { ...formData, ticketId: data?.ticketId };
    if (!isValidString(postData?.comment))
      return setError({ comment: "required!" })
    dispatch(postTicketAction(postData, () => {
      dispatch(getTicketList());
      setFormData(initFormData);
      handleClose();
    }));
  }

  const handleCancel = () => {
    setFormData(initFormData);
    handleClose();
  }

  const handleFocus = e => {
    setError({ ...error, [e.target.name]: "" })
  }

  return (
    <Modal show={show} onHide={handleClose} size="lg" className="tiket-model">
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="modal-title title tiket-heading fs-4 fw-bold">Close Ticket</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="subject" className="form-label fw-semibold">Subject</label>
          <input type="text" className="form-control" name="title" value={formData?.title} disabled />
        </div>
        <div className="mb-3">
          <label htmlFor="textarea" className="form-label fw-semibold">
            Closing remark <span className="text-danger">* </span>
            <span className="text-danger">{error?.comment}</span>
          </label>
          <textarea name="comment" onFocus={handleFocus} onChange={handleInputChange} value={formData?.comment} className="form-control" rows="5" ></textarea>
        </div>
        <div className="uploader contact-uploader">
          <input type="file" onChange={handleFileChange} className="form-control rounded-0" id="inputGroupFile01" multiple />
          <div className="wrapp">
            <div className="uploader-content">
              <div>{formData?.attachments?.[0]?.fileUrl}</div>
              <div className="upload-icon"><img src={upload} /></div>
              <a className={`btn mt-4 bg-blue`}>Attach file</a>
            </div>
          </div>
        </div>
      </Modal.Body>
      <div className="row bottom-btn my-4 tickt-row justify-content-between mx-0 px-4">
        <div className="col-6 col-md-6 col-lg-6">
          <div className="d-grid gap-2">
            <button className="btn btns btn-left" type="button" data-bs-dismiss="modal" onClick={handleCancel}>Cancel</button>
          </div>
        </div>
        <div className="col-6 col-md-6 col-lg-6">
          <div className="d-grid gap-2">
            <button className="btn btns btn-right" type="button" data-bs-dismiss="modal" onClick={handleCloseTicket}>Close ticket</button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default CloseTicket;
